import S from './SoonBadge.module.scss'

interface SoonBadgeProps {
  label: string
  /** Placement tweaks by the host (e.g. keep the chip inside a full-width CTA). */
  className?: string
}

// Absolute-positioned "Soon" chip for not-yet-released actions. The caller owns
// the positioning context (a relative wrapper around the disabled control) and
// supplies the localized label. aria-hidden because the accessible name is
// carried by the host control's aria-label, e.g. "Make a post (Soon)".
const SoonBadge = ({ label, className }: SoonBadgeProps) => (
  <span
    className={className ? `${S.badge} ${className}` : S.badge}
    aria-hidden="true"
  >
    {label}
  </span>
)

export default SoonBadge
